if (!customElements.get('subscription-widget')) {
  customElements.define(
    'subscription-widget',
    class SubscriptionWidget extends HTMLElement {
          constructor() {
            super();
          }
          init() {
             this.inputs = this.querySelectorAll('input');
             this.widgetWrapper = this.querySelector('.recharge-widget');
             this.onetimePriceElement = document.querySelectorAll('.product-form__submit [js-onetime-price]');
             this.subsPriceElement = document.querySelectorAll('.product-form__submit [js-subs-price]');
             this.form = document.querySelector('.sticky-atc__button form');
            this.sellingPlanInput = document.querySelector('#selling-plan-input'); 
            this.sellingPlanId = document.querySelector('[js-selling-plan]'); 
             this.inputs.forEach((input)=> {
               input.addEventListener('change', this.onChangeHandler.bind(this));
             });
          }
          connectedCallback() {
            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);
                this.init();
            };
            
            new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
            document.addEventListener("subscription-widget:init", () => {
              new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
            })
      }
          onChangeHandler(evt) {
           const existingInput = this.form?.querySelector('#selling-plan-input');
              evt.preventDefault();
              if(evt.target.checked) {
                
                this.widgetWrapper.classList.add('selected');
                this.onetimePriceElement.forEach((onetimePriceElement) => {
                  onetimePriceElement.classList.add('hidden');
                })
                this.subsPriceElement.forEach((subsPriceElement) => {
                  subsPriceElement.classList.remove('hidden');
                })
                 if (!existingInput) {
                  const input = document.createElement('input');
                  input.type = 'hidden';
                  input.id = 'selling-plan-input';
                  input.name = 'selling_plan';
                  input.value = this.sellingPlanId.value ;
                  input.className = 'selling-plan-id';
                  this.form?.appendChild(input);
                }
              } 
              else {
                 this.widgetWrapper.classList.remove('selected');
                 this.onetimePriceElement.forEach((onetimePriceElement) => {
                  onetimePriceElement.classList.remove('hidden');
                })
                this.subsPriceElement.forEach((subsPriceElement) => {
                  subsPriceElement.classList.add('hidden');
                })
                if (existingInput) {
                  existingInput.remove();
                }
              }
          }
       }
  );
}